const imgURL = (src, replace) => {
  const url = new URL(src);
  const regex = /\.(jpg|jpeg|png)/i;
  const matches = src.match(regex);

  return `//${url.hostname}${url.pathname.replace(regex, `_${replace}x${matches[0]} ${replace}w`)}`;
};

const getImage = ({ height, width, src, alt }) => {
  const srcSet = [];
  if (width >= 320) {
    srcSet.push(imgURL(src, '320'));
  }
  if (width >= 500) {
    srcSet.push(imgURL(src, '500'));
  }
  if (width >= 800) {
    srcSet.push(imgURL(src, '800'));
  }
  if (width >= 1000) {
    srcSet.push(imgURL(src, '1000'));
  }
  if (width >= 1200) {
    srcSet.push(imgURL(src, '1200'));
  }
  // if (width >= 1400) {
  //   srcSet.push(imgURL(src, '1400'));
  // }
  // if (width >= 1600) {
  //   srcSet.push(imgURL(src, '1600'));
  // }
  // if (width >= 1800) {
  //   srcSet.push(imgURL(src, '1800'));
  // }

  return `
  <img
    alt="${alt}"
    class="lazyload"
    data-sizes="auto"
    data-srcset="${srcSet.join(',')}"
    height="${height}"
    src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
    width="${width}"
  />`;
};

export default getImage;
